<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!--<img src="img/avatars/6.jpg" class="img-avatar" :alt="user.nombreUsuario">-->
      <i class="nav-icon icon-user"></i>&nbsp; {{user.nombreUsuario}}
    </template>
    <template slot="dropdown">
      <!--<b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <b-dropdown-item>
        <i class="fa fa-bell-o"/> Updates
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-envelope-o"/> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-tasks"/> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-comments"/> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item>
        <i class="fa fa-user"/> Profile
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-wrench"/> Settings
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-usd"/> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-file"/> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item>
        <i class="fa fa-shield"/> Lock Account
      </b-dropdown-item>-->
      <b-dropdown-header tag="div" class="text-center">
        <strong>Cuenta</strong>
      </b-dropdown-header>
      <b-dropdown-item v-on:click="frontlogout">
        <i class="icon-lock"/> Cerrar Sesión
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import UserService from '../services/user.service';

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data() {
    return {
      user: this.$store.getters["auth/infoUser"] || "{}"
    };
  },
  methods: {
    frontlogout(){
      this.$validator
      .validateAll()
      this.$swal({
          type: "warning",
          title: 'Cerrar Sesión',
          text: "¿Está Seguro que Desea Cerrar Sesión?",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: 'Sí, Salir',
          cancelButtonText: "No, Continuar"
        })
      .then(res => {
        if (res.value == true){
          var promise = new Promise(res => {
            res(this.$store.dispatch('auth/logout', this.user))
          });
        };
      })
    }
  }
}
</script>
